import { memo } from 'react';
import { Route, Routes } from 'react-router-dom';
import AllRoleplaysApp from 'components/apps/AllRoleplaysApp';
import DialogApp from 'components/apps/DialogApp';
import NotFoundApp from 'components/apps/NotFoundApp';
import PasswordRecoveryApp from 'components/apps/PasswordRecoveryApp';
import PrivacyPolicyApp from 'components/apps/PrivacyPolicyApp';
import PublicGamesApp from 'components/apps/PublicGamesApp';
import PublicScenariosApp from 'components/apps/PublicScenariosApp';
import GuestRootPage from 'components/apps/RootPages/GuestRootPage';
import StripeStatusApp from 'components/apps/StripeStatusApp';
import TermsOfServiceApp from 'components/apps/TermsOfServiceApp/TermsOfServiceApp';
import AuthStateWrapper from 'components/common/AuthStateWrapper';
import CharacterPage from 'pages/CharacterPage';
import ChatPage from 'pages/ChatPage';
import CpaPage from 'pages/CpaPage/CpaPage';
import ScenariosGeneratorPage from 'pages/ScenariosGeneratorPage';
import TagPage from 'pages/TagPage';
import { GUEST_ROUTES } from 'routes/routes';

const GuestRouter = () => {

  return (
    <Routes>
      <Route path={GUEST_ROUTES.CPA()} element={<CpaPage />} />
      <Route path={GUEST_ROUTES.RECOVER()} element={<PasswordRecoveryApp />} />
      <Route path={GUEST_ROUTES.PUBLIC_SCENARIOS()} element={<PublicScenariosApp />} />
      <Route path={GUEST_ROUTES.PUBLIC_GAMES()} element={<PublicGamesApp />} />
      <Route path={GUEST_ROUTES.DIALOG()} element={<DialogApp />} />
      <Route path={GUEST_ROUTES.ROLEPLAY()} element={<DialogApp />} />
      <Route path={GUEST_ROUTES.STRIPE_CB()} element={<StripeStatusApp />} />
      <Route path={GUEST_ROUTES.ALL_ROLEPLAYS()} element={<AllRoleplaysApp />} />
      <Route path={GUEST_ROUTES.NOT_FOUND()} element={<NotFoundApp />} />
      <Route path={GUEST_ROUTES.PRIVACY_POLICY()} element={<PrivacyPolicyApp />} />
      <Route path={GUEST_ROUTES.TERMS_OF_SERVICE()} element={<TermsOfServiceApp />} />
      <Route path={GUEST_ROUTES.TAG()} element={<TagPage />} />
      <Route path={GUEST_ROUTES.CHAT()} element={<ChatPage />} />
      <Route path={GUEST_ROUTES.CHARACTER()} element={<CharacterPage />} />
      <Route
        path={GUEST_ROUTES.SCENARIOS_GENERATOR()}
        element={
          <AuthStateWrapper requireAuth showSpinner>
            <ScenariosGeneratorPage />
          </AuthStateWrapper>
        }
      />
      <Route path={GUEST_ROUTES.ROOT()} element={<GuestRootPage />} />
      <Route path={GUEST_ROUTES.NOT_FOUND()} element={<NotFoundApp />} />
    </Routes>
  );
};

export default memo(GuestRouter);